<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<mat-dialog-content>
  <h1 class="mat-headline-5">{{ displayName }}</h1>

  <dash-gis-file-upload (uploadSelected)="setFileToUpload($event)"
    [accept]='data.accept'
    [disabled]='filesToUpload.length >= data.maxFiles'
  [maxFiles]='data.maxFiles - filesToUpload.length'></dash-gis-file-upload>
  <div class="file-list-container">
    @for (file of filesToUpload; track file; let i = $index) {
      <div
        fxLayout="row" fxLayoutAlign="space-between center">
        <div>{{ file.name }}</div>
        <button mat-icon-button (click)="removeFile(i)">
          <mat-icon svgIcon="cancel-circle" class="dash-gis-icon-18p" aria-label="Remove file entry"></mat-icon>
        </button>
      </div>
    }
  </div>

  <dash-gis-data-form-content [formName]='data.form'
    (shouldClose)='shouldCloseDialog($event)'
    (setDisplayName)='setDisplayName($event)'
  (isValid)='isFormValid($event)'></dash-gis-data-form-content>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <div fxLayout="row" fxLayoutAlign="end center">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-button (click)="doUpload()" [disabled]="!isReadyToUpload">Upload</button>
  </div>
</mat-dialog-actions>

